import React, { useEffect, useState } from 'react';

const TwinklingStars = () => {
  const [stars, setStars] = useState([]);

  useEffect(() => {
    // Generate random twinkling stars
    const generateStars = () => {
      const newStars = [];
      for (let i = 0; i < 100; i++) {
        newStars.push({
          id: i,
          left: Math.random() * 100,
          top: Math.random() * 100,
          size: Math.random() * 2 + 1, // 1-3px
          delay: Math.random() * 4,
          duration: 2 + Math.random() * 4 // 2-6s
        });
      }
      setStars(newStars);
    };
    generateStars();
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-[1]">
      {stars.map(star => (
        <div
          key={star.id}
          className="absolute rounded-full bg-yellow-300"
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            boxShadow: '0 0 4px rgba(251, 191, 36, 0.8)',
            animation: `twinkle ${star.duration}s ease-in-out ${star.delay}s infinite`
          }}
        />
      ))}
    </div>
  );
};

export default TwinklingStars;
